



import LoginMobile from '../sections/login/template_01';






import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";


const LoginPageMobile = ()=>{
  
return (
  <div id="loginPageMobile" class="page ">
  
  

  
  <LoginMobile mobileTitleToggle={ true } />
  
  
  
  

  
  {/* < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `footer_banner` } supportLanguage={
    true } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
   */}
  
  

  
</div>
)
}

export default LoginPageMobile;